import { Box, Typography } from '@material-ui/core'

const DataExpandablePanel = ({ record }) => {
  if (!record) return null

  return (
    <Box my={2} mx={2}>
      <Box mt={2}>
        <Typography variant='body2' color='textSecondary'>
          Additional Details
        </Typography>
        <Box display='flex' flexWrap='wrap' mt={1}>
          <Box mr={4} mb={2}>
            <Typography variant='caption' color='textSecondary'>
              Process
            </Typography>
            <Typography variant='body2'>{record.process || 'N/A'}</Typography>
          </Box>
          <Box mr={4} mb={2}>
            <Typography variant='caption' color='textSecondary'>
              Log ID
            </Typography>
            <Typography variant='body2'>{record.logId || 'N/A'}</Typography>
          </Box>
          <Box mr={4} mb={2}>
            <Typography variant='caption' color='textSecondary'>
              Sequence
            </Typography>
            <Typography variant='body2'>{record.sequence || 'N/A'}</Typography>
          </Box>
          <Box mr={4} mb={2}>
            <Typography variant='caption' color='textSecondary'>
              Log received timestamp
            </Typography>
            <Typography variant='body2'>{record.logTimestamp || 'N/A'}</Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default DataExpandablePanel
